import Vue from 'vue'
import loading from 'vuejs-loading-screen'

const parameterBackgroundColor = (new URLSearchParams(window.location.search)).get('background')

Vue.use(loading, {
    bg: parameterBackgroundColor ? '#' + parameterBackgroundColor : 'rgb(0 0 0 / 0.5)',
    size: 5,
    slot: '<i class="fas fa-globe fa-pulse fa-3x fa-fw" style="color:#fff"></i>',
})